<template>
  <div>
    <LogTimeLoggerPopover
      :task="task"
      :key="loggedTime"
      :open.sync="isPopoverOpen"
      :disabled="disabled"
      @update="(time) => $emit('update', time)"
    >
      <LogTimeButton
        :button-classes="[
          'direction-left',
          { 'is-active': isPopoverOpen || loggedTime !== '0h' },
        ]"
        :tooltip="$t('Log time')"
        icon="clock"
      />
    </LogTimeLoggerPopover>
  </div>
</template>
<script>
import LogTimeButton from '@widgets/TaskDetailWidgets/LogTimeButton';
import LogTimeLoggerPopover from '@widgets/LogTimeLoggerPopover/LogTimeLoggerPopover';

export default {
  name: 'LogTimeLogger',
  components: {
    LogTimeButton,
    LogTimeLoggerPopover,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loggedTime: {
      type: String,
      required: true,
    },
    showTimeList: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPopoverOpen: {
      get() {
        return this.open;
      },
      set(newVal) {
        this.$emit('update:open', newVal);
      },
    },
  },
};
</script>
<style>
.log-time__wrapper div {
  height: 100%;
}
</style>
